// extracted by mini-css-extract-plugin
module.exports = {"date":"ProcedureTableInfo_date__1kgzz","head":"ProcedureTableInfo_head__uhlyD"};